let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hCK89")).then(() => parcelRequire('61dq6'));